import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./confirm.css";

const INK = "#0066CC";

// لوحة توقيع بالفأرة/اللمس — DPR-aware، لا تُمسح عند إعادة رسم الأب.
export const SignaturePad = ({ onChange }) => {
  const { t } = useTranslation();
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const resize = () => {
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      const w = Math.max(1, Math.floor(rect.width * dpr));
      const h = Math.max(1, Math.floor(rect.height * dpr));
      if (canvas.width === w && canvas.height === h) return;
      const prev = dirty.current ? canvas.toDataURL("image/png") : null;
      canvas.width = w; canvas.height = h;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.lineWidth = 2.4; ctx.lineCap = "round"; ctx.lineJoin = "round";
      ctx.strokeStyle = INK;
      if (prev) {
        const img = new Image();
        img.onload = () => ctx.drawImage(img, 0, 0, rect.width, rect.height);
        img.src = prev;
      }
    };
    const point = (e) => {
      const rect = canvas.getBoundingClientRect();
      const s = e.touches ? e.touches[0] : e;
      return { x: s.clientX - rect.left, y: s.clientY - rect.top };
    };
    const start = (e) => {
      e.preventDefault(); drawing.current = true;
      const { x, y } = point(e); ctx.beginPath(); ctx.moveTo(x, y);
    };
    const move = (e) => {
      if (!drawing.current) return;
      e.preventDefault();
      const { x, y } = point(e); ctx.lineTo(x, y); ctx.stroke();
      dirty.current = true;
    };
    const end = () => {
      if (!drawing.current) return;
      drawing.current = false;
      onChangeRef.current?.(canvas.toDataURL("image/png"));
    };
    resize();
    const ro = new ResizeObserver(resize);
    ro.observe(canvas);
    canvas.addEventListener("mousedown", start);
    canvas.addEventListener("mousemove", move);
    window.addEventListener("mouseup", end);
    canvas.addEventListener("touchstart", start, { passive: false });
    canvas.addEventListener("touchmove", move, { passive: false });
    canvas.addEventListener("touchend", end);
    return () => {
      ro.disconnect();
      canvas.removeEventListener("mousedown", start);
      canvas.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", end);
      canvas.removeEventListener("touchstart", start);
      canvas.removeEventListener("touchmove", move);
      canvas.removeEventListener("touchend", end);
    };
  }, []);

  const clear = () => {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    dirty.current = false;
    onChangeRef.current?.("");
  };

  return (
    <div className="grid gap-2">
      <canvas ref={canvasRef} data-testid="signature-canvas" className="pc-canvas" />
      <button type="button" className="pc-clear" data-testid="signature-clear" onClick={clear}>
        {t("purchases.confirm.clearSignature")}
      </button>
    </div>
  );
};
